import api from './api';
import types from './mutation-types';

export default {
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setSearchParam_({ commit }, { key, value }) {
		//{key : key, value : value}
		commit(types.SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	getPopupCpny_({ commit, state }) {
		const { searchParams, pagingInfo } = state;
		return api
			.getPopupCpny({ searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit })
			.then(data => {
				if (data.header.code === 0) {
					// 기존 정상 처리
					const { pagingInfo, resultList } = data.body;
					commit(types.CPNY_LIST, data !== null && data !== undefined ? resultList : null);
					commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo });
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
					// http status 는 성공이지만 내부적으로 오류일경우 catch 로 빠지게 하는식으로?
					// throw data
					// const { pagingInfo, resultList } = data.body;
					// commit(types.PART_LIST, data !== null && data !== undefined ? resultList : null);
					// commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo });
					// commit(types.DEFAULT_ASSIGN, { key: 'partList', value: resultList });
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	calRpymAmt_({ commit, state }, param) {
		//신청할때 체크함
		//console.log('파람', param);
		return api
			.calRpymAmt(param)
			.then(data => {
				if (data.header.code === 0) {
					if (data.body.result !== null) {
						commit(types.DEFAULT_ASSIGN, { key: 'roNo', value: data.body.result.roNo });
						commit(types.DEFAULT_ASSIGN, { key: 'mtrlCst', value: data.body.result.mtrlCst });
						commit(types.DEFAULT_ASSIGN, { key: 'dvswRt', value: data.body.result.dvswRt });
						commit(types.DEFAULT_ASSIGN, { key: 'aplDvswRt', value: data.body.result.aplDvswRt });
						commit(types.DEFAULT_ASSIGN, { key: 'rpymAmt', value: data.body.result.rpymAmt });
						commit(types.DEFAULT_ASSIGN, { key: 'aplRpymAmt', value: data.body.result.aplRpymAmt });
					}
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}
};
